<template>
  <div class="nav-menu">
    <button>1. Upload Statement</button> >
    <button>2. Upload Remittance</button> >
    <button>3. Select Payments</button> >
    <button>4. Complete</button>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        status: {},
      }
    },
    methods: {

    },
    name: 'ResultPage',
  }
</script>

<style>
    .nav-menu {
        width: 900px;
        margin: 0 auto;
        padding: 16px 32px;
        border: 0;
        border-radius: 4px;
        justify-content: left;
        align-items: center; 
    }

    button {
        line-height: 38px; 
        margin: 10px;
        text-align: center; 
        padding: 0 30px; 
        vertical-align: middle; 
        font-size: .875rem; 
        color: #fff; 
        background-color: #1e87f0; 
        border: 1px solid transparent;
        font-weight: bold;
        border-radius: 4px;
    }

    button:disabled {
        background-color: #cccccc;
        color: #858585;
    }
</style>